<template>
<section class="assessmentSection page-systemReview systemReviewPhone">
    <div class="bg-white-cover"></div>
    <div class="pageContent">
        <div class="pageCompleted">System review | Optional review</div>

        <transition name="fadeUp" mode="out-in">
            <!-- STARTING TEXT -->
            <div v-if="!phoneFilled" key="1">
                <div class="pageTitle">Want to review your quote with a guide?</div>
                <div class="pageText">
                    Guides are security specialists who can review your system with you. You can leave your number here for a guide to contact you or click “Talk with a guide”
                </div>
            </div>
    
            <!-- FOCUSED TEXT -->
            <div v-if="phoneFilled" key="2">
                <div class="pageTitle">Do we have permission to call you?</div>
                <div class="pageText">
                    Select "I agree" for a guide to reach out to you and help you with a system review
                </div>
            </div>
        </transition>

        <transition name="fadeHeight">
            <div class="avatars" v-if="!phoneFilled">
                <img src="/img/system-review-avatars.png" alt="Guides">
            </div>
        </transition>

        <!-- PHONE INPUT -->
        <div class="systemReview-Input">
            <div class="inputGroup">
                <input 
                    ref="phoneInput"
                    placeholder="What's your phone number?"
                    type="tel" 
                    v-mask="'(###) ###-####'"
                    v-model="phone"
                />
            </div>
            <transition name="fade">
                	<img 
                	    v-if="phoneFilled"
                	    class="checkmark" 
                	    src="/img/checkmark.png" 
                	    alt="checkmark" 
                	/>
                </transition>
        </div>
        <!-- END PHONE INPUT -->

        <transition name="fadeUp" mode="out-in">
            <div v-if="!phoneFilled"></div>
            <true-panel v-if="phoneFilled">
                <transition name="fade" mode="out-in">
                    <TalkWithGuideConsent ref="consentComponent" v-if="!consented" :hasButton="false" :hasPhone="false" />
                    <TalkWithGuideConfirmation v-if="consented" :hasDone="false" />
                </transition>
            </true-panel>
        </transition>
    </div>


    <transition name="fade">
        <continue-button v-if="!phoneFilled" :before="declineSystemReviewTracking" to="/system" text="No thanks" />
        <div class="text-center" v-if="consentToCall && !consented">
            <button class="button" @click="consent">Let's talk</button>
        </div>
        <continue-button v-if="consented" to="/system" />
    </transition>
</section>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { mapActions, mapGetters, mapState } from 'vuex'
import FormInput from '../components/FormInput.vue'
import TalkWithGuideConsent from '../components/TalkWithGuide/TalkWithGuideConsent.vue'
import TalkWithGuideConfirmation from '../components/TalkWithGuide/TalkWithGuideConfirmation.vue'
export default {
    components: {
        FormInput,
        TalkWithGuideConsent,
        TalkWithGuideConfirmation
    },
    data: () => ({
        phoneFilled: false,
        consented: false,
        phone: '',
    }),
    computed: {
        ...mapState(['uuid', 'lead', 'consentToCall']),
        ...mapGetters(['selectedPlan']),
    },
    methods: {
        ...mapActions(['updateSystem']),

        declineSystemReviewTracking() {
            mixpanel.track('deniedSystemReview')
        },

        async consent() {
            let data = {
                uuid: this.uuid,
                phone: this.phone,
                consentText: this.$refs.consentComponent.$refs.consentText.textContent
            }
            let res = await axios.post('/ajax/ticket/system-review', data)
            axios.post(`/api/systemReviewRequest/${res.data.leadId}/${res.data.consentId}`)
            this.consented = true
            mixpanel.track('requestedSystemReview')
        }
    },
    mounted () {
        gtag('event', 'conversion', {'send_to': 'AW-879819493/jWL7CMC4_IIBEOX1w6MD'});
        this.updateSystem()
        this.$watch('phone', (newValue) => {
            if (newValue) {
                let length = newValue.length
                this.phoneFilled = length === 14
                if (this.phoneFilled) {
                    $('body, html').scrollTop(0)
                    this.lead.phone = this.phone
                }
            } else {
                this.phoneFilled = false
            }
        })
    }
}
</script>

<style lang="css"></style>
